<style scoped="scoped" lang="scss">
._demo /deep/.el-transfer-panel:last-child {
  border-right: none;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/formed/archives/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <!--						<yi_cross_select :component="'web_base_equipment_list'" :max="1"-->
            <!--							:ids.sync="yt.conditions.equipmentId"></yi_cross_select>-->

            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('muhao')">
            <el-input v-model="yt.conditions.mouldNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" @click="yt.showEditDialog('xinzengdangan', scope.row, 'w1')" type="primary" v-if="utils.checkPower('web_process_management_forming_file_create')">
          {{ $t('xinzengdangan') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('huoqudangan', scope.row, 'w1')" plain v-if="utils.checkPower('web_process_management_forming_file_get')">
          {{ $t('huoqudangan') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiafachengxingdangan', scope.row, 'w1')">
              {{ $t('xiafachengxingdangan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fuzhidangan', scope.row, 'w1')">
              {{ $t('fuzhidangan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzengdangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <yi_cross_select :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :max="1" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
          </el-form-item>
          <el-form-item style="display: flex;flex-wrap: nowrap;" :label="$t('chengxingdangan')" required>
            <yi_upload :accept="'mcm,mld'" :ids.sync="yt.editObj.fileId" :limit="1">
              <div slot="limitMsg"></div>
            </yi_upload>
            <div>
              <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                {{ $t('zuiduoshangchuan') }}
              </span>
              <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                <span>1</span>
                <span style="color: #909399;font-size: 14px;font-weight: normal;">
                  {{ $t('zizhichiwenjian') }}
                </span>
              </span>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/craft/formed/archives/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 获取档案 -->
      <template v-if="yt.editObj.action == 'huoqudangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <yi_cross_select :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
          </el-form-item>
          <!--         <div style="display: flex;flex-wrap: nowrap">-->
          <div>
            <el-form-item :label="$t('mohao')" required>
              <div style="overflow: auto;height: 160px;width: 192px;border: 1px solid #eae9e9">
                <el-checkbox-group style="margin-left: 8px" v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in getMouldNoList" :label="city" :key="city">{{ city }} </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <!--           <div>-->
          <!--             <el-button type="primary" size="mini" @click="yt.req('GET','/web/craft/formed/archives/getMouldNo')" plain>{{$t('huoqumohao')}}</el-button>-->
          <!--           </div>-->
          <!--         </div>-->
          <!--          <div style="display: flex;flex-wrap: nowrap">-->
          <div>
            <el-form-item :label="$t('chengxingdangan')" required>
              <el-input v-model="filesName"> </el-input>
            </el-form-item>
          </div>
          <!--            <div>-->
          <!--              <el-button type="primary" size="mini" @click="yt.req('GET','/web/craft/formed/archives/getArchives')" plain>{{$t('huoqudangan')}}</el-button>-->
          <!--            </div>-->
          <!--          </div>-->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="saveForm" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 复制档案 -->
      <template v-if="yt.editObj.action == 'fuzhidangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div style="font-size: 16px;color: #303133;font-weight: 400">{{ $t('yuanchengxingdanganxinxi') }}</div>
          <el-form-item class="noborder" :label="$t('shebeiSNshebeimingcheng')" required style="margin-top: 10px">
            <yi_cross_select disabled :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :max="1" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('mohao')" required>
            <el-input disabled v-model="yt.editObj.mouldNo"></el-input>
          </el-form-item>
          <div style="font-size: 16px;color: #303133;font-weight: 400">{{ $t('xiugaihouchengxingdanganxinxi') }}</div>
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required style="margin-top: 10px">
            <yi_cross_select :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :max="1" :ids.sync="yt.editObj.equipmentIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('mohao')" required>
            <el-input v-model="yt.editObj.mouldNos"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/craft/formed/archives/copy', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'xiafachengxingdangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yuesutiaojian')" required style="margin-top: 10px">
            <yi_dictionary_select :max="1" multiple :type="'CONSTRAINT_CONDITION'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <el-select :disabled="disabledEquipment" filterable :clearable="true" v-model="yt.editObj.equipmentIds">
              <el-option v-for="(item, index) in equipmentList" :key="index" :label="item.equipmentSnAndName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="saveSumit" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// const cityOptions = ['mo123.#001', 'mo123.#002', 'mo123.#003', 'mo123.#004','mo123.#005'];
// const cityOptions = this.getMouldNoList;
export default {
  name: 'web_process_management_forming_file_list',
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      getMouldNoList: [],
      getFileNameMap: {},
      filesName: null,
      mouldNoName: null,
      // checkedCities: ['mo123.#001'],
      cities: this.getMouldNoList,
      isIndeterminate: true,
      selectedData: [],
      equipmentList: [],
      disabledEquipment: true,
      data: [
        {
          key: 1,
          label: this.$t('xuanxiang') + 1
        },
        {
          key: 2,
          label: this.$t('xuanxiang') + 2
        },
        {
          key: 3,
          label: this.$t('xuanxiang') + 3
        },
        {
          key: 4,
          label: this.$t('xuanxiang') + 4
        },
        {
          key: 5,
          label: this.$t('xuanxiang') + 5
        }
      ],
      titles: [this.$t('kexuanxiang'), this.$t('yixuanxiang')],
      props: {
        key: 'key',
        label: 'label'
      },
      codeAndDesc: '',
      columns: [
        {
          label: 'shebeiSN',
          prop: 'equipment.sn',
          width: 180
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 180
        },
        {
          label: 'mohao',
          prop: 'mouldNo',
          width: 180
        },
        {
          label: 'chengxingdangan',
          prop: 'fileName'
          // width: 180,
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.editObj': {
      handler(n, o) {
        if (n.value) {
          this.getArchivalEquipment();
          this.disabledEquipment = false;
        }
        console.log('ccccccccccc', n);
      },
      immediate: false,
      deep: true
    },
    'yt.isShowEditDialog': {
      handler(n, o) {
        if (n == false) {
          this.disabledEquipment = true;
          this.getMouldNoList = [];
          this.checkedCities = [];
          this.filesName = '';
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.equipmentId': {
      handler(n) {
        if (n) {
          this.getMouldNo();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      console.log(this.yt.get(1));
      this.yt.get(1);
    }, 300);
  },
  methods: {
    handleCheckedCitiesChange(value) {
      if (this.checkedCities.length > 1) {
        this.checkedCities.splice(0, 1);
      }
      this.mouldNoName = value + '';
      const mid = '.mid';
      this.filesName = this.getMouldNoFileName(value);
      console.log('hhhhhhhhhh', this.filesName);
    },
    //获取档案保存
    saveForm() {
      let params = {
        mouldNo: this.mouldNoName,
        equipmentId: this.yt.editObj.equipmentId
        // oldEquipmentId: this.yt.editObj.equipmentId
      };
      return this.http
        .post('/web/craft/formed/archives/getArchives/save', params)
        .then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },
    //下发成型档案保存
    saveSumit() {
      let params = {
        mouldNo: this.yt.editObj.mouldNo,
        newEquipmentId: this.yt.editObj.equipmentIds,
        oldEquipmentId: this.yt.editObj.equipmentId
      };
      return this.http
        .post('/web/craft/formed/archives/validMould', params)
        .then(response => {
          if (response.data == false) {
            this.yt.isShowEditDialog = false;
            this.utils.successMessage(this.$t(response.msg));
          }
          if (response.data == true) {
            //当前模号的序号已经存在，是否自动修改序号再下发?
            this.$confirm(this.$t('zidongxiugaixuhao'), this.$t('jinggao'), {
              confirmButtonText: this.$t('shi'),
              cancelButtonText: this.$t('fou'),
              type: 'warning'
            })
              .then(() => {
                this.getDistributeMoldingFiles();
                this.yt.isShowEditDialog = false;
              })
              .catch(() => {});
          }
          // console.log('fffffffv',response.data)
          // this.yt.isShowEditDialog = false
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },
    // craft/formed/archives/distributeMoldingFiles
    getDistributeMoldingFiles() {
      let params = {
        mouldNo: this.yt.editObj.mouldNo,
        newEquipmentId: this.yt.editObj.equipmentIds,
        oldEquipmentId: this.yt.editObj.equipmentId
      };
      return this.http
        .post('/web/craft/formed/archives/distributeMoldingFiles', params)
        .then(response => {
          this.utils.successMessage(this.$t(response.msg));
          // this.yt.isShowEditDialog = false
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },
    beforeAdd(params, url) {
      params.oldId = params.id;
      params.equipmentId = params.equipmentIds;
      params.mouldNo = params.mouldNos;
      return params;
    },
    getArchivalEquipment() {
      this.http
        .get('/web/equipment/standing_book/getArchivalEquipment', {
          params: {
            equipmentId: this.yt.editObj.equipmentId,
            constraintConditionValue: this.yt.editObj.value,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.equipmentList = res.data;
        });
    },
    getMouldNo() {
      this.http
        .get('/web/craft/formed/archives/getMouldNo', {
          params: {
            equipmentId: this.yt.editObj.equipmentId
          }
        })
        .then(res => {
          this.getMouldNoList = res.data.moldNoList;
          this.getFileNameMap = res.data.fileNameMap;
          console.log('data', res.data);
        });
    },
    getMouldNoFileName(key) {
      return this.getFileNameMap[key];
    }
  }
};
</script>
